/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderTotal
 */
export interface OrderTotal {
    /**
     * 
     * @type {number}
     * @memberof OrderTotal
     */
    invoiceTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTotal
     */
    contractTotal: number;
}

/**
 * Check if a given object implements the OrderTotal interface.
 */
export function instanceOfOrderTotal(value: object): value is OrderTotal {
    if (!('invoiceTotal' in value) || value['invoiceTotal'] === undefined) return false;
    if (!('contractTotal' in value) || value['contractTotal'] === undefined) return false;
    return true;
}

export function OrderTotalFromJSON(json: any): OrderTotal {
    return OrderTotalFromJSONTyped(json, false);
}

export function OrderTotalFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderTotal {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceTotal': json['invoiceTotal'],
        'contractTotal': json['contractTotal'],
    };
}

export function OrderTotalToJSON(json: any): OrderTotal {
    return OrderTotalToJSONTyped(json, false);
}

export function OrderTotalToJSONTyped(value?: OrderTotal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceTotal': value['invoiceTotal'],
        'contractTotal': value['contractTotal'],
    };
}

